import { TableContratos } from "./Components/table/TableContratos";

export const PageContratos = () => {
  return <TableContratos />;
};
